

















import _ from "lodash";
import Vue from "vue";
import { mapMutations } from "vuex";
import ForecastDay from "@/components/ForecastDay.vue";
import Geolocation from "@/services/geolocation.ts";
import OpenWeatherAPI from "@/services/open-weather-api.ts";
import getUnit from "@/helpers/get-unit.ts";
import getConditionName from "@/helpers/get-condition-name.ts";

export default Vue.extend({
  components: {
    ForecastDay
  },

  data: () => ({
    isLoading: true,
    coordinates: {} as Coordinates,
    temperature: 0,
    unit: "",
    rawCondition: "",
    forecast: [] as {
      weather: string;
      min: number;
      max: number;
    }[]
  }),

  computed: {
    absoluteTemperature(): number {
      return Math.abs(this.temperature);
    },

    unitLetter() {
      return this.unit[0].toUpperCase();
    },

    condition(): string {
      return _(this.rawCondition).capitalize();
    }
  },

  mounted() {
    this.unit = getUnit();
    this.fetchWeatherData();
  },

  methods: {
    ...mapMutations(["setTitle", "setCurrentCondition"]),

    async fetchCurrentWeather() {
      const { latitude: lat, longitude: lon } = this.coordinates;
      const { data } = await OpenWeatherAPI.fetch("weather", {
        lat,
        lon
      });

      this.setTitle(data.name);
      this.temperature = Math.round(data.main.temp);
      this.rawCondition = getConditionName(data.weather[0].id);
      this.setCurrentCondition(this.rawCondition);
    },

    async fetchForecast5Days() {
      const { latitude: lat, longitude: lon } = this.coordinates;
      const { data } = await OpenWeatherAPI.fetch("onecall", {
        lat,
        lon,
        exclude: "current,minutely,hourly"
      });

      this.forecast = _(data.daily)
        .drop()
        .take(5)
        .map(day => ({
          weather: getConditionName(day.weather[0].id),
          min: Math.round(day.temp.min),
          max: Math.round(day.temp.max)
        }))
        .value();
    },

    async fetchWeatherData() {
      const isGeolocationEnabled = await Geolocation.isEnabled();

      if (isGeolocationEnabled) {
        await Geolocation.get(
          async ({ coords }: { coords: Coordinates }) => {
            this.coordinates = coords;
            await Promise.all([
              this.fetchCurrentWeather(),
              this.fetchForecast5Days()
            ]);
            this.isLoading = false;
          },
          ({ code, message }: { code: number; message: string }) => {
            console.warn(`ERROR(${code}): ${message}`);
          }
        );
      } else {
        this.$router.replace({ name: "Onboarding" });
      }
    }
  }
});
